<template>
  <div class="contact-container">
    <section class="section1 w1200">
      <div class="top-content">
        <div class="content-left">
          <h1 :class="{ h1: locale === 'en' }" v-animate class="page-title">
            {{ $t("about.text1") }}
          </h1>
          <div v-animate class="info-content">
            <div>
              <p v-html="$t('about.text2')"></p>
            </div>
            <div>
              <p v-html="$t('about.text3')"></p>
            </div>
            <div>
              <p v-html="$t('about.text4')"></p>
            </div>
          </div>
        </div>
        <div v-animate class="content-right">
          <img src="@/assets/images/influenbase-contact-us-icon1.png" alt="" />
        </div>
      </div>
      <div class="top-brand">
        <img v-animate src="@/assets/images/influenbase-about-brand-logo1.png" alt="" />
        <img v-animate src="@/assets/images/influenbase-about-brand-logo2.png" alt="" />
        <img v-animate src="@/assets/images/influenbase-about-brand-logo3.png" alt="" />
        <img v-animate src="@/assets/images/influenbase-about-brand-logo4.png" alt="" />
        <img v-animate src="@/assets/images/influenbase-about-brand-logo5.png" alt="" />
      </div>
    </section>

    <section class="section2">
      <h1 v-animate class="page-title">{{ $t("about.text5") }}</h1>

      <div class="content-box">
        <div class="box-item" v-for="(item, index) in courseData" :key="index">
          <span class="item-time">{{ item.time }}</span>
          <div class="item-circle">
            <div class="item-circle-inner"></div>
          </div>
          <div class="item-desc">
            <div v-animate>{{ item.desc }}</div>
          </div>
        </div>
      </div>
    </section>

    <section class="section3 w1200">
      <div class="about-animation">
        <div class="animation-box animation-top">
          <span v-animate>{{ $t("about.text6") }}</span>
        </div>
        <div class="animation-box animation-bottom">
          <span v-animate>
            {{ $t("about.text7") }}
          </span>
        </div>

        <div class="animation-other">
          <div class="shadow-box shadow-box-bottom"></div>

          <div class="line line1"></div>
          <div class="line line2"></div>
          <div class="line line3"></div>
        </div>

        <div class="animation-brand" :class="{ 'animation-brand-active': isActive }">
          <img src="@/assets/images/influenbase-about-brand1.png" alt="" />
          <img src="@/assets/images/influenbase-about-brand2.png" alt="" />
          <img class="hidden" src="@/assets/images/influenbase-about-brand3.png" alt="" />
          <img class="hidden" src="@/assets/images/influenbase-about-brand4.png" alt="" />
          <img src="@/assets/images/influenbase-about-brand5.png" alt="" />
          <img src="@/assets/images/influenbase-about-brand6.png" alt="" />
          <img src="@/assets/images/influenbase-about-brand7.png" alt="" />
          <img class="hidden" src="@/assets/images/influenbase-about-brand8.png" alt="" />
          <img class="hidden" src="@/assets/images/influenbase-about-brand9.png" alt="" />
        </div>
      </div>

      <div class="about-case">
        <div class="case-left">
          <div v-animate class="case case1">
            <img src="@/assets/images/influenbase-about-case1.png" alt="" />
          </div>
          <div v-animate class="case case2">
            <img src="@/assets/images/influenbase-about-case3.png" alt="" />
          </div>
          <div v-animate class="case case3">
            <p>
              <span>{{ $t("about.text8") }}</span>
            </p>
            <p>
              <span>{{ $t("about.text9") }}</span>
            </p>
            <p>
              <span>{{ $t("about.text10") }}</span>
            </p>
            <p>
              <span>{{ $t("about.text12") }}</span>
            </p>
            <p>
              <span>{{ $t("about.text13") }}</span>
            </p>
            <p>
              <span>{{ $t("about.text14") }}</span>
            </p>
          </div>
        </div>
        <div class="case-right">
          <div v-animate class="case case1">
            <img src="@/assets/images/influenbase-about-case2.png" alt="" />
          </div>
          <div v-animate class="case case2">
            <img src="@/assets/images/influenbase-about-case4.png" alt="" />
          </div>
          <div v-animate class="case case3">
            <img src="@/assets/images/influenbase-about-case5.png" alt="" />
          </div>
        </div>
      </div>
    </section>

    <section class="section4 w1200">
      <h1 v-animate class="page-title">{{ $t("about.text15") }}</h1>
      <p v-animate>{{ $t("about.text16") }}</p>
      <p v-animate>{{ $t("about.text17") }}</p>
      <!-- <p v-animate>{{ $t("about.text18") }}</p> -->
      <!-- <p v-animate>{{ $t("about.text20") }}</p> -->

      <div class="img-box">
        <img src="@/assets/images/influenbase-about-case-1.webp" alt="" />
        <img src="@/assets/images/influenbase-about-case-2.webp" alt="" />
        <template v-if="locale === 'zh'">
          <div class="img-box3">
            <img src="@/assets/images/influenbase-about-case-zh4.webp" alt="" />
            <img src="@/assets/images/influenbase-about-case-zh1.webp" alt="" />
            <img src="@/assets/images/influenbase-about-case-zh2.webp" alt="" />
            <img src="@/assets/images/influenbase-about-case-zh3.webp" alt="" />
          </div>
        </template>
        <template v-else>
          <img src="@/assets/images/influenbase-about-case-en3.webp" alt="" />
        </template>
      </div>
    </section>

    <section class="section5 w1200">
      <img v-animate src="@/assets/images/influenbase-carousel-icon2.png" alt="" />
      <span v-animate>{{ $t("about.text21") }}</span>
    </section>
  </div>

  <img
    class="w-[100px] h-[131px] fixed right-[40px] top-[48vh] cursor-pointer tool-img"
    :src="toolImg"
    alt=""
    @click="handleOpenDialog"
  />

  <contactDialog v-model="showDialog"></contactDialog>
</template>

<script setup lang="ts">
import { onUnmounted } from "vue";
import { ref } from "vue";
import contactDialog from "@/components/Dialog/contactDialog.vue";
import { usePageAbout } from "@/hooks/usePageAbout.ts";

const { toolImg, handleOpenDialog, showDialog, courseData, locale } = usePageAbout();

const isActive = ref(false);
const setIsActive = () => {
  const animationBottom = document.querySelector(".animation-bottom");
  if (animationBottom) {
    const rect = animationBottom.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // 当 animation-bottom 元素出现在窗口中时
    if (rect.top < windowHeight && rect.bottom > 0 && !isActive.value) {
      isActive.value = true;
    }
  }
};

window.addEventListener("scroll", setIsActive);

onUnmounted(() => {
  window.removeEventListener("scroll", setIsActive);
});
</script>

<style scoped lang="scss">
.contact-container {
  min-height: 100vh;
  padding-top: 3.25rem; /* 为固定导航栏留出空间 */
  background: #fefcff;
}

.page-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 64px;
  color: #000000;
}

.tool-img {
  z-index: 20;
}

.section1 {
  .top-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 160px;

    .content-left {
      height: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-family: PingFang SC, PingFang SC;
      font-weight: 300;
      font-size: 28px;
      color: #000000;
      line-height: 40px;

      h1 {
        margin-bottom: 80px;
      }

      div {
        margin-bottom: 30px;
        :deep(span) {
          font-weight: 500;
          font-size: 28px;
        }
      }
      div:last-child {
        margin-bottom: 0;
      }
    }

    .content-right {
      margin-left: 64px;
      padding-top: 70px;
      img {
        width: 480px;
      }
    }
  }

  .top-brand {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 147px;
    img:nth-child(1) {
      width: 153px;
      height: 43px;
    }
    img:nth-child(2) {
      width: 114px;
      height: 64px;
    }
    img:nth-child(3) {
      width: 183px;
      height: 40px;
    }
    img:nth-child(4) {
      width: 142px;
      height: 44px;
    }
    img:nth-child(5) {
      width: 215px;
      height: 42px;
    }
  }
}

.section2 {
  margin-top: 172px;
  text-align: center;

  .content-box {
    display: flex;
    justify-content: center;
    position: relative;
    margin-top: 80px;

    &::before {
      content: "";
      width: 100vw;
      min-width: 1200px;
      height: 4px;
      background: #f1e5ff;
      position: absolute;
      top: 76px;
      z-index: 1;
    }

    .box-item {
      width: 246px;
      margin-right: 35px;

      .item-time {
        margin-bottom: 14px;
        font-family: Techna Sans, Techna Sans;
        font-weight: 500;
        font-size: 36px;
        color: #9038ff;
      }

      .item-circle {
        width: 48px;
        height: 48px;
        background: #f1e5ff;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
        position: relative;
        .item-circle-inner {
          position: absolute;
          z-index: 2;
          width: 18px;
          height: 18px;
          background: #9038ff;
          border-radius: 50%;
        }
      }

      .item-desc {
        padding: 30px;
        background: #ffffff;
        box-shadow: 0px 16px 20px 0px rgba(187, 172, 195, 0.18);
        border-radius: 12px 12px 12px 12px;
        text-align: left;
        min-height: 300px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
        line-height: 40px;
        position: relative;
        margin-top: 44px;

        &::before {
          content: "";
          width: 2px;
          height: 60px;
          background: #9038ff;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: -60px;
        }
      }
    }
    .box-item:last-child {
      margin-right: 0;
    }
  }
}

.section3 {
  margin-top: 162px !important;
  position: relative;
  padding-bottom: 1020px;

  .about-animation {
    height: auto;
    position: relative;

    .animation-box {
      height: 601px;
      justify-content: center;
      align-items: flex-end;
      display: flex;
      font-weight: 400;
      font-size: 60px;
      color: #2e1b53;

      span {
        margin-bottom: 20px;
      }
    }

    .animation-bottom {
      color: #858481;
      font-size: 20px;
      align-items: flex-start;

      span {
        display: block;
        width: 500px;
        margin-top: 20px;
        text-align: center;
      }
    }

    .animation-other {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .line {
        z-index: 0;
        position: absolute;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        border: 1px solid #bfb9ea;
        opacity: 0.66;
        transform: translateX(-50%) translateY(calc(-50%));
      }

      .line1 {
        width: 640px;
        height: 640px;
      }

      .line2 {
        width: 952px;
        height: 952px;
      }
      .line3 {
        width: 1200px;
        height: 1200px;
      }

      .shadow-box {
        position: absolute;
        left: 0;
        height: 220px;
        width: 100%;
        z-index: 1;
      }

      .shadow-box-bottom {
        bottom: 0;
        background: linear-gradient(to top, #fbfaff, 98%, transparent);
      }

      .animation-brand {
        position: absolute;
        top: 0;
        left: 0;
      }
    }

    .animation-brand {
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        z-index: 2;
        transition: all 0.5s ease-in-out;
        opacity: 0;
      }

      img:nth-child(1) {
        width: 100px;
        height: 100px;
      }

      img:nth-child(2) {
        width: 145px;
        height: 44px;
      }

      img:nth-child(3) {
        width: 247px;
        height: 48px;
      }

      img:nth-child(4) {
        width: 119px;
        height: 66px;
      }

      img:nth-child(5) {
        width: 141px;
        height: 53px;
      }

      img:nth-child(6) {
        width: 100px;
        height: 100px;
      }

      img:nth-child(7) {
        width: 145px;
        height: 50px;
      }

      img:nth-child(8) {
        width: 174px;
        height: 54px;
      }
      img:nth-child(9) {
        width: 195px;
        height: 37px;
      }
    }

    .animation-brand-active {
      img {
        opacity: 1;
      }
      img:nth-child(1) {
        transform: translateX(calc(-50% - 430px)) translateY(calc(-50% - 430px));
        @media screen and (max-width: 1200px) {
          transform: translateX(calc(-50% - 230px)) translateY(calc(-50% - 410px));
        }
      }

      img:nth-child(2) {
        transform: translateX(calc(-50% - 450px)) translateY(calc(-50% - 130px));
        @media screen and (max-width: 1200px) {
          transform: translateX(calc(-50% - 230px)) translateY(calc(-50% - 200px));
        }
      }

      img:nth-child(3) {
        transform: translateX(calc(-50% - 410px)) translateY(calc(-50% + 200px));
        @media screen and (max-width: 1200px) {
          transform: translateX(calc(-50% - 205px)) translateY(calc(-50% + 200px));
        }
      }

      img:nth-child(4) {
        transform: translateX(calc(-50% - 160px)) translateY(calc(-50% + 440px));
      }

      img:nth-child(5) {
        transform: translateX(calc(-50%)) translateY(calc(-50% - 470px));
      }

      img:nth-child(6) {
        transform: translateX(calc(-50% + 160px)) translateY(calc(-50% - 270px));
        @media screen and (max-width: 1200px) {
          transform: translateX(calc(-50% + 60px)) translateY(calc(-50% - 310px));
        }
      }

      img:nth-child(7) {
        transform: translateX(calc(-50% + 460px)) translateY(calc(-50% - 130px));
        @media screen and (max-width: 1200px) {
          transform: translateX(calc(-50% + 280px)) translateY(calc(-50% - 160px));
        }
      }

      img:nth-child(8) {
        transform: translateX(calc(-50% + 460px)) translateY(calc(-50% + 150px));
        @media screen and (max-width: 1200px) {
          transform: translateX(calc(-50% + 240px)) translateY(calc(-50% + 200px));
        }
      }
      img:nth-child(9) {
        transform: translateX(calc(-50% + 260px)) translateY(calc(-50% + 400px));
      }
    }
  }

  .about-case {
    display: flex;
    position: absolute;
    bottom: -0;
    z-index: 700;

    > div {
      flex: 1;
      .case {
        margin-bottom: 24px;
        img {
          width: 100%;
        }
      }
    }
    .case1 {
      img {
        height: 444px;
      }
    }

    .case-left {
      margin-right: 24px;
      .case2 {
        img {
          height: 438px;
        }
      }

      .case3 {
        background: #f4f4f4;
        border-radius: 32px 32px 32px 32px;
        padding: 26px 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 20px;
        color: #402d81;
        line-height: 28px;

        p {
          position: relative;
          display: flex;
          align-items: flex-start;
          flex-wrap: wrap;

          &::before {
            content: "";
            width: 6px;
            height: 6px;
            border-radius: 50%;
            overflow: hidden;
            background-color: #402d81;
            margin-top: 12px;
          }

          span {
            flex: 1;
            padding-left: 14px;
          }
        }
      }
    }
    .case-right {
      .case2,
      .case3 {
        img {
          height: 343px;
        }
      }
    }
  }
}

.section4 {
  text-align: center;
  margin-top: 210px !important;
  h1 {
    margin-bottom: 66px;
  }

  p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 40px;
    color: #402d81;
  }

  .img-box {
    width: 1030px;
    margin: auto;
    padding: 32px;
    padding-top: 0;
    background: #f7f0fe;
    margin-top: 80px;
    border-radius: 32px 32px 32px 32px;
    img {
      width: 100%;
      margin-top: 32px;
    }
    .img-box3 {
      overflow: hidden;
      img {
        float: left;
        width: 50%;
      }
      img:nth-child(1) {
        width: calc(50% - 70px);
        margin-right: 32px;
      }
    }
  }
}

.section5 {
  margin-top: 160px !important;
  text-align: center;
  padding-bottom: 170px !important;
  img {
    width: 40px;
    height: 26px;
    vertical-align: top;
  }
  span {
    font-family: PingFang SC, PingFang SC;
    font-weight: 300;
    font-size: 64px;
    color: #adadad;
    line-height: 100px;
    text-align: center;
    flex: 1;
    overflow: hidden;
  }
}

.w1200 {
  width: 1200px;
  margin: auto;
}
</style>
